import { render, staticRenderFns } from "./FinalDocumentListItem.vue?vue&type=template&id=3fe9be48&"
import script from "./FinalDocumentListItem.vue?vue&type=script&lang=ts&"
export * from "./FinalDocumentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports